import { TextLink } from '@redbubble/design-system';
import { ReactNode } from 'react';

/*
  This component can be injected into "intl" messages
  and the text in and out of the <link> tags can be
  easily localised.

  An example for you:

  ```
  export const messages = defineMessages({
    prompt: {
      defaultMessage:
        'By proceeding to checkout, I agree to Redbubble’s <link>User Agreement</link>',
    },
  });

  const onClick = () => {
    console.log("Sending UA click to GTM...");
  }

  return (
    <Box>
      {intl.formatMessage(messages.prompt, {
        link: LocalisableLink(agreementUrl, onClick),
      })}
    </Box>
  )
  ```
*/

export const LocalisableLink =
  (href: string | undefined | null, onClick?: () => void) =>
  (str: ReactNode) => {
    if (!href) return str;
    return (
      <TextLink href={href} onClick={onClick}>
        {str}
      </TextLink>
    );
  };
